// Generated types for RequirementSatisfactionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface RequirementSatisfactionTaskReadAPI extends LLMTaskReadAPI {
}

export interface RequirementSatisfactionTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const RequirementSatisfactionTaskReadAPISchema: z.ZodType<RequirementSatisfactionTaskReadAPI> = LLMTaskReadAPISchemaObject.extend({}).passthrough();

export const RequirementSatisfactionTaskWriteAPISchema: z.ZodType<RequirementSatisfactionTaskWriteAPI> = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
